import { http } from '@/utils/http' // eslint-disable-line
import { doLogin, doLogout, getUserProfile } from '@/services/AuthService'
import * as types from '../mutations'

const state = {
  isLoggedin: false,
  authToken: '',
  profile: {}
}

const getters = {
  authToken: (state) => state.authToken,
  isLoggedin: (state) => state.isLoggedin,
  profile: (state) => state.profile
}

const actions = {

  async login ({ commit, dispatch }, { email, password }) {
    let token = await doLogin({ email, password })
    commit(types.LOGIN)
    dispatch('setAuthToken', { token: token })
    http.main.setAuthToken(token)
    await dispatch('getUserProfile')
  },

  async getUserProfile ({ commit }) {
    let profile = await getUserProfile()
    commit(types.SET_USER_PROFILE, profile)
  },

  logout ({ commit, dispatch }) {
    dispatch('codes/clearCodeSelection', null, {root: true})
    dispatch('transactions/clearTransactionSelection', null, {root: true})
    doLogout()
    commit(types.LOGOUT)
  },

  setAuthToken ({ commit }, { token }) {
    commit(types.SET_AUTH_TOKEN, token)
    if (token) {
      commit(types.LOGIN)
    }
  }
}

const mutations = {

  [types.SET_AUTH_TOKEN] (state, token) {
    state.authToken = token
  },

  [types.LOGIN] (state) {
    state.isLoggedin = true
  },

  [types.LOGOUT] (state) {
    state.isLoggedin = false
    state.authToken = ''
  },

  [types.SET_USER_PROFILE] (state, profile) {
    state.profile = profile
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
